import React, {useState, useContext} from 'react'
import { Result, Divider, Form, Input, Button, message } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import {
    Link,
  } from 'react-router-dom';

import {useFetch} from '@utils'
import { appContext } from '../AppContext';

export default function ResetPasswordPage() {

    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const email = urlParams.get('email')
    
    const [doFetch, FetchType] = useFetch();
    const [result, setResult] = useState(undefined)
    const [appState] = useContext(appContext);

    const layout = {
        labelCol: { span: 0 },
        wrapperCol: { span: 16 },
      };
      const tailLayout = {
        wrapperCol: { offset: 0, span: 16 },
      };

      function onFinish(values) {
        if(values.password !== values.repeatPassword) {
            message.error('Password is not the same')
            return;
        }


        const url = `/api/Account/ResetPassword`;

        const body = {
            password: values.password,
            forgotToken : token,
            email: email
        }

        doFetch(url, FetchType.POST, body)
            .then((response) => {
                if(response.isSuccess) {
                    setResult(true);
                    return;
                }

                message.error('Failed to reset your password. Please use another password or contact someone from the LarpTOM team')
            })
    }

    if(result !== undefined) {
        return (
            <div className={"main"}>
                <img src={process.env.PUBLIC_URL + '/image/logo.png'} alt="Logo"/>
                <h2>Password reset</h2>
                <Result
                status="success"
                title="Reset password"
                subTitle="Your password has been reset"
                extra={[
                    <Link to={`/${appState.appName}/login`}>Login</Link>
                ]}
                />
            </div>
            )
    }

    return (
        <div className={"main"}>
        <img src={process.env.PUBLIC_URL + '/image/logo.png'} alt="Logo"/>
        <h2>Password reset</h2>
        <p>Please fill in a new password</p>
        <Form
                {...layout}
                name="basic"
                onFinish={onFinish}
                requiredMark
                >
                <Form.Item
                    label="Password"
                    name="password"
                    rules={[{ required: true, message: 'Please input your password!' }]}
                    tooltip={{ title: `Password must contain: minimum 8 characters, a digit, a special character, a capital letter  `, icon: <InfoCircleOutlined /> }}
                >
                    <Input.Password />
                </Form.Item>

                <Form.Item
                    label="Repeat password"
                    name="repeatPassword"
                    rules={[{ required: true, message: 'Please input your password!' }]}
                >
                    <Input.Password />
                </Form.Item>

                <Form.Item {...tailLayout}>
                    <Button type="primary" htmlType="submit">
                    Submit
                    </Button>
                </Form.Item>
            </Form>
            <Divider />
            <Link to={`/${appState.appName}/login`}>Login</Link>
        </div>
    )
}